// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown_dropdown__2Z72V","label":"dropdown_label__1x44k","menu":"dropdown_menu__1yG33","menuItem":"dropdown_menuItem__2PKJS"};